import { Repository } from './common/repository.class'
import { RepositoryStrategyEnum } from 'src/shared/enum/repository-strategy.enum'
import { IConfig } from '@shared/interface/config.interface'
import { dbGetConfig, dbSetConfig } from '@data/datasource/local/config.database'
import { apiGetConfig } from '@data/datasource/remote/config.api'

class ConfigRepository extends Repository {
  constructor() {
    super()
  }

  /*****************************************
  *
  * GET FUNCTIONS
  *
  *****************************************/

  // Get current user's devices
  async getConfig(forcedStrategy?: RepositoryStrategyEnum): Promise<IConfig | undefined> {
    const finalStrategy = forcedStrategy ?? this.repositoryStragtegy

    if (finalStrategy === RepositoryStrategyEnum.LOCAL_FIRST) {
      return dbGetConfig()
        .then(conf => {
          if (conf == null) {
            return apiGetConfig()
              .then(toLocalConf => {
                dbSetConfig(toLocalConf)
                return toLocalConf
              })
          } else {
            apiGetConfig().then(cfg => dbSetConfig(cfg))
            return conf
          }
        })
    } else {
      return await apiGetConfig()
        .then(conf => {
          dbSetConfig(conf)
          return conf
        })
        .catch(() => dbGetConfig())
    }
  }
}

export default new ConfigRepository()
